import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Iconify from '../Iconify';
import PropTypes from 'prop-types';

export function ServerUnavailableDialog({ open, message, retrying, onRetry }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      fullScreen={isMobile}
      disableEscapeKeyDown
      aria-labelledby="server-unavailable-title"
    >
      <DialogTitle id="server-unavailable-title" sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Iconify icon="mdi:cloud-off-outline" width={28} height={28} color="#EA5E00" />
          <Typography variant="h6" component="span" sx={{ fontWeight: 700, color: '#182E45' }}>
            Serveur inaccessible
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography sx={{ color: '#3F5265', lineHeight: 1.6, mb: 2 }}>
          {message || 'Impossible de joindre le serveur pour le moment.'}
        </Typography>
        <Typography sx={{ color: '#637381', fontSize: 14, lineHeight: 1.5 }}>
          Cela peut survenir pendant un déploiement ou une maintenance. Vos données locales sont
          conservées — réessayez dans quelques instants.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, pt: isMobile ? 1 : 0 }}>
        <Button
          variant="contained"
          onClick={onRetry}
          disabled={retrying}
          fullWidth={isMobile}
          startIcon={retrying ? <CircularProgress size={18} color="inherit" /> : null}
          sx={{
            backgroundColor: '#EA5E00',
            '&:hover': { backgroundColor: '#c44f00' },
            textTransform: 'none',
            fontWeight: 600,
            minWidth: 140,
            minHeight: 48,
          }}
        >
          {retrying ? 'Vérification…' : 'Réessayer'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ServerUnavailableDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string,
  retrying: PropTypes.bool,
  onRetry: PropTypes.func.isRequired,
};
